/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */

import { library } from '@fortawesome/fontawesome-svg-core';

// Brands
import { faAppStore as fabAppStore } from '@fortawesome/free-brands-svg-icons/faAppStore';
import { faGooglePlay as fabGooglePlay } from '@fortawesome/free-brands-svg-icons/faGooglePlay';
import { faFacebook as fabFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram as fabInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin as fabLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faPinterest as fabPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest';
import { faTumblr as fabTumblr } from '@fortawesome/free-brands-svg-icons/faTumblr';
import { faTwitter as fabTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faXTwitter as fabXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faYoutube as fabYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faBloggerB as fabBloggerB } from '@fortawesome/free-brands-svg-icons/faBloggerB';

// Regular
import { faAt as farAt } from '@fortawesome/pro-regular-svg-icons/faAt';
import { faAward as farAward } from '@fortawesome/pro-regular-svg-icons/faAward';
import { faBadge as farBadge } from '@fortawesome/pro-regular-svg-icons/faBadge';
import { faBell as farBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faBook as farBook } from '@fortawesome/pro-regular-svg-icons/faBook';
import { faCalendar as farCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faCalendarAlt as farCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faCircleDollar as farCircleDollar } from '@fortawesome/pro-regular-svg-icons/faCircleDollar';
import { faClock as farClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faDollarSign as farDollarSign } from '@fortawesome/pro-regular-svg-icons/faDollarSign';
import { faDownload as farDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { faEnvelope as farEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faExclamationTriangle as farExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';
import { faFileCertificate as farFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faHandWave as farHandWave } from '@fortawesome/pro-regular-svg-icons/faHandWave';
import { faNewspaper as farNewspaper } from '@fortawesome/pro-regular-svg-icons/faNewspaper';
import { faHandshake as farHandshake } from '@fortawesome/pro-regular-svg-icons/faHandshake';
import { faHeart as farHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faMemoCircleCheck as farMemoCircleCheck } from '@fortawesome/pro-regular-svg-icons/faMemoCircleCheck';
import { faPrint as farPrint } from '@fortawesome/pro-regular-svg-icons/faPrint';
import { faSearch as farSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faSearchPlus as farSearchPlus } from '@fortawesome/pro-regular-svg-icons/faSearchPlus';
import { faStroopwafel as farStroopwafel } from '@fortawesome/pro-regular-svg-icons/faStroopwafel';
import { faTriangleExclamation as farTriangleExclamation } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import { faUser as farUser } from '@fortawesome/pro-regular-svg-icons/faUser';

// Light
import { faCalendar as falCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar';
import { faAward as falAward } from '@fortawesome/pro-light-svg-icons/faAward';
import { faList as falList } from '@fortawesome/pro-light-svg-icons/faList';
import { faHome as falHome } from '@fortawesome/pro-light-svg-icons/faHome';
import { faDollarSign as falDollarSign } from '@fortawesome/pro-light-svg-icons/faDollarSign';
import { faHandWave as falHandWave } from '@fortawesome/pro-light-svg-icons/faHandWave';
import { faMegaphone as falMegaphone } from '@fortawesome/pro-light-svg-icons/faMegaphone';
import { faExclamationTriangle as falExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { faGraduationCap as falGraduationCap } from '@fortawesome/pro-light-svg-icons/faGraduationCap';
import { faNewspaper as falNewspaper } from '@fortawesome/pro-light-svg-icons/faNewspaper';
import { faChartLine as falChartLine } from '@fortawesome/pro-light-svg-icons/faChartLine';
import { faBookOpenReader as falBookOpenReader } from '@fortawesome/pro-light-svg-icons/faBookOpenReader';

// Solid
import { faAward as fasAward } from '@fortawesome/pro-solid-svg-icons/faAward';
import { faAlignRight as fasAlignRight } from '@fortawesome/pro-solid-svg-icons/faAlignRight';
import { faAngleLeft as fasAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faAngleRight as fasAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faAt as fasAt } from '@fortawesome/pro-solid-svg-icons/faAt';
import { faBan as fasBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faBars as fasBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBookReader as fasBookReader } from '@fortawesome/pro-solid-svg-icons/faBookReader';
import { faBug as fasBug } from '@fortawesome/pro-solid-svg-icons/faBug';
import { faBuilding as fasBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding';
import { faBullhorn as fasBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faCalendar as fasCalendar } from '@fortawesome/pro-solid-svg-icons/faCalendar';
import { faCaretDown as fasCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretLeft as fasCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import { faChartLine as fasChartLine } from '@fortawesome/pro-solid-svg-icons/faChartLine';
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle as fasCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faChevronLeft as fasChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleNotch as fasCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faCity as fasCity } from '@fortawesome/pro-solid-svg-icons/faCity';
import { faClipboardCheck as fasClipboardCheck } from '@fortawesome/pro-solid-svg-icons/faClipboardCheck';
import { faClock as fasClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faDollarSign as fasDollarSign } from '@fortawesome/pro-solid-svg-icons/faDollarSign';
import { faDownload as fasDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faEnvelope as fasEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faExclamationTriangle as fasExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faFilePdf as fasFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faFax as fasFax } from '@fortawesome/pro-solid-svg-icons/faFax';
import { faGlobe as fasGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faGraduationCap as fasGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faHandshake as fasHandshake } from '@fortawesome/pro-solid-svg-icons/faHandshake';
import { faHandWave as fasHandWave } from '@fortawesome/pro-solid-svg-icons/faHandWave';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHome as fasHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faImages as fasImages } from '@fortawesome/pro-solid-svg-icons/faImages';
import { faKey as fasKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faLink as fasLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faList as fasList } from '@fortawesome/pro-solid-svg-icons/faList';
import { faLock as fasLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faLongArrowLeft as fasLongArrowLeft } from '@fortawesome/pro-solid-svg-icons/faLongArrowLeft';
import { faMap as fasMap } from '@fortawesome/pro-solid-svg-icons/faMap';
import { faMapMarker as fasMapMarker } from '@fortawesome/pro-solid-svg-icons/faMapMarker';
import { faMapMarkerAlt as fasMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt';
import { faMegaphone as fasMegaphone } from '@fortawesome/pro-solid-svg-icons/faMegaphone';
import { faNewspaper as fasNewspaper } from '@fortawesome/pro-solid-svg-icons/faNewspaper';
import { faPhone as fasPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faPrint as fasPrint } from '@fortawesome/pro-solid-svg-icons/faPrint';
import { faSearch as fasSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faSearchPlus as fasSearchPlus } from '@fortawesome/pro-solid-svg-icons/faSearchPlus';
import { faShare as fasShare } from '@fortawesome/pro-solid-svg-icons/faShare';
import { faShieldAlt as fasShieldAlt } from '@fortawesome/pro-solid-svg-icons/faShieldAlt';
import { faSignOutAlt as fasSignOutAlt } from '@fortawesome/pro-solid-svg-icons/faSignOutAlt';
import { faStroopwafel as fasStroopwafel } from '@fortawesome/pro-solid-svg-icons/faStroopwafel';
import { faThList as fasThList } from '@fortawesome/pro-solid-svg-icons/faThList';
import { faTimes as fasTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faTreasureChest as fasTreasureChest } from '@fortawesome/pro-solid-svg-icons/faTreasureChest';
import { faTrophy as fasTrophy } from '@fortawesome/pro-solid-svg-icons/faTrophy';
import { faPlay as fasPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faUpload as fasUpload } from '@fortawesome/pro-solid-svg-icons/faUpload';
import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faVideo as fasVideo } from '@fortawesome/pro-solid-svg-icons/faVideo';
import { faWindowClose as fasWindowClose } from '@fortawesome/pro-solid-svg-icons/faWindowClose';
import { faSignInAlt as fasSignInAlt } from '@fortawesome/pro-solid-svg-icons/faSignInAlt';
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faCommentDots as fasCommentDots } from '@fortawesome/pro-solid-svg-icons/faCommentDots';
import { faFileCertificate as fasFileCertificate } from '@fortawesome/pro-solid-svg-icons/faFileCertificate';

const exports = {
  fabAppStore,
  fabGooglePlay,
  fabFacebook,
  fabInstagram,
  fabLinkedin,
  fabPinterest,
  fabTumblr,
  fabTwitter,
  fabXTwitter,
  fabYoutube,
  fabBloggerB,
  farAt,
  farAward,
  farBadge,
  farBell,
  farBook,
  farCalendar,
  farCalendarAlt,
  farCheckCircle,
  farCircleDollar,
  farClock,
  farDollarSign,
  farDownload,
  farEnvelope,
  farExclamationTriangle,
  farFileCertificate,
  farHandWave,
  farNewspaper,
  farHandshake,
  farHeart,
  farMemoCircleCheck,
  farPrint,
  farSearch,
  farSearchPlus,
  farStroopwafel,
  farTriangleExclamation,
  farUser,
  falCalendar,
  falAward,
  falList,
  falHome,
  falDollarSign,
  falHandWave,
  falMegaphone,
  falExclamationTriangle,
  falGraduationCap,
  falNewspaper,
  falChartLine,
  falBookOpenReader,
  fasAward,
  fasAlignRight,
  fasAngleLeft,
  fasAngleRight,
  fasAt,
  fasBan,
  fasBars,
  fasBookReader,
  fasBug,
  fasBuilding,
  fasBullhorn,
  fasCalendar,
  fasCaretDown,
  fasCaretLeft,
  fasChartLine,
  fasCheck,
  fasCheckCircle,
  fasChevronLeft,
  fasCircle,
  fasCircleNotch,
  fasCity,
  fasClipboardCheck,
  fasClock,
  fasDollarSign,
  fasDownload,
  fasEnvelope,
  fasExclamationTriangle,
  fasFilePdf,
  fasFax,
  fasGlobe,
  fasGraduationCap,
  fasHandshake,
  fasHandWave,
  fasHeart,
  fasHome,
  fasImages,
  fasKey,
  fasLink,
  fasList,
  fasLock,
  fasLongArrowLeft,
  fasMap,
  fasMapMarker,
  fasMapMarkerAlt,
  fasMegaphone,
  fasNewspaper,
  fasPhone,
  fasPrint,
  fasSearch,
  fasSearchPlus,
  fasShare,
  fasShieldAlt,
  fasSignOutAlt,
  fasStroopwafel,
  fasThList,
  fasTimes,
  fasTreasureChest,
  fasTrophy,
  fasPlay,
  fasUpload,
  fasUser,
  fasVideo,
  fasWindowClose,
  fasSignInAlt,
  fasStar,
  fasCommentDots,
  fasFileCertificate,
};

export default library.add(...Object.values(exports));

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */